import React from "react";
import Day from "./Day";

class Weather extends React.Component {
  render() {
    const {
      time: date,
      weathercode: codes,
      temperature_2m_max: max,
      temperature_2m_min: min,
    } = this.props.weatherData;

    return (
      <div>
        <h2>Weather {this.props.location}</h2>
        <ul className="weather">
          {date.map((date, i) => (
            <Day
              date={date}
              max={max.at(i)}
              min={min.at(i)}
              code={codes.at(i)}
              key={date}
              isToday={i === 0}
            />
          ))}
        </ul>
      </div>
    );
  }
}

export default Weather;
